<div class="d-flex flex-row w-100 h-100">
  <app-navigation></app-navigation>
  <app-chabot></app-chabot>
  <div class="flex-fill overflow-auto w-100">
    <router-outlet></router-outlet>
  </div>
</div>
